<template>
    <div style="visibility: hidden;" class="page" 
        data-loaded="false" :id="pageContainerId" 
        data-page-number="pageNumber" 
        @mousedown="mouseDown" 
        @mouseup="mouseUp"
        @contextmenu="preventContext($event)">
        
        <div class="canvasWrapper">
            <canvas :id="`page${pageNumber}`" :height="pageHeight" :width="pageWidth" ></canvas>
        </div>
        <div class="textLayer"></div>
    </div>
</template>

<script>
// Vendor
import Utils from '@/lib/Utils';
import { PDFJS } from 'pdfjs-dist/web/pdf_viewer';

// Component

PDFJS.workerSrc = '../../../node_modules/pdfjs-dist/build/pdf.worker.js';

const ProjectPdfPage = {
    name: 'ProjectPdfPage',
    props: ['page', 'pageWidth', 'pageHeight'],
    components: {
        // 'resize-sensor': resizeSensor
    },
    data: function() {
        return {
            pdfRender: null,
            pageNumber: this.$props.page.pageNumber,
            pdfPage: this.$props.page.pdfPage,
            pageContainerId: 'pageContainer' + this.$props.page.pageNumber
        };
    },
    methods: {
        renderPage: function() {
            const canvas = this.$el.querySelector('.canvasWrapper canvas');
            const canvasContext = canvas.getContext('2d', {alpha: false});
            // Deep copy of the viewport so we don't get changes halfway through.
            const viewport = Utils.getViewport(this.pdfPage, canvas.width, canvas.height);
            const transform = Utils.scalePage(this.$el, viewport, canvasContext);
            // Render the page
            console.log(`RENDER PAGE ${this.pageNumber}`);
            this.pdfRender = this.pdfPage.render({ canvasContext, viewport, transform })
            .then(() => {
                // Indicate that the page was loaded
                this.$el.setAttribute('data-loaded', 'true');
                return this.pdfPage.getTextContent({normalizeWhitespace: true})
                .then((textContent) => {
                    const textLayer = this.$el.querySelector('.textLayer');
                    textLayer.innerHTML = '';
                    const textLayerFactory = new PDFJS.DefaultTextLayerFactory();
                    const textLayerBuilder = textLayerFactory.createTextLayerBuilder(
                        textLayer, this.pageNumber, viewport, true);
                    textLayerBuilder.setTextContent(textContent);
                    textLayerBuilder.render();

                    this.$emit('pdfLoaded', 
                        {pageText: textContent, pageNumber: this.pageNumber, viewport: viewport});
                    console.log(`RENDERED PAGE ${this.pageNumber}`);
                });
            });
        },
        mouseDown: function(e) {
            console.log(e);
            if ((e.button === 2) || (e.button === 0 && (e.metaKey || e.ctrlKey))) {
                e.preventDefault();
                this.createPositionCue(e);
            }
        },
        mouseUp: function(e) {
            if (e.button === 0) {
                this.createSelectionCue();
            }
        },
        createSelectionCue: function() {
            const selection = window.getSelection();
            const text = selection.toString();
            if (text) {
                const canvas = this.$el.querySelector('.canvasWrapper canvas');
                const bounds = canvas.getBoundingClientRect();

                const range = selection.getRangeAt(0); 
                const rect = range.getBoundingClientRect();

                const cue = {
                    type: 'selection',
                    width: rect.width,
                    height: rect.height,
                    x: rect.x - bounds.x,
                    y: rect.y - bounds.y
                };
                this.$emit('cueCreated', cue);
            }
        },
        createPositionCue: function(e) {
            const canvas = this.$el.querySelector('.canvasWrapper canvas');
            const bounds = canvas.getBoundingClientRect();

            const cue = {
                type: 'position',
                x: e.clientX - bounds.x,
                y: e.clientY - bounds.y,
                width: 10,
                height: 10
            };

            this.$emit('cueCreated', cue);
        },
        preventContext: function(e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    },
    mounted: function() {
        this.renderPage();
    }
};

export default ProjectPdfPage;
</script>

<style>
.textLayer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.2;
  line-height: 1.0;
}

.textLayer > div {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  -webkit-transform-origin: 0% 0%;
  -moz-transform-origin: 0% 0%;
  -o-transform-origin: 0% 0%;
  -ms-transform-origin: 0% 0%;
  transform-origin: 0% 0%;
}

.textLayer::selection { background: rgb(0,0,255); }
.textLayer::-moz-selection { background: rgb(0,0,255); }

</style>


// WEBPACK FOOTER //
// pdf-page.vue?6ad19280